import React, { useState } from "react";
import useHandleFilePath from "../../hooks/useHandleFilePath";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSelectedItems } from "../../redux/slices/contentSlice/contentForm/contentForm";
const AudioFileSelector = ({ audioFiles, setAudioFiles }) => {
  const csvBatchData = useSelector((state) => state.contentForm.csvBatchData);

  const dispatch = useDispatch();

  const { handleFilePath } = useHandleFilePath();

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    files.forEach((file, index) => {
      const title = csvBatchData?.title?.[index]?.value;
      const { filePath } = handleFilePath(file, title);
      dispatch(
        setSelectedItems({
          filePath,
          masterFile: URL.createObjectURL(file),
          type: file.type,
        })
      );
    });
    setAudioFiles(files);
  };

  return (
    <div>
      <input
        type="file"
        accept="audio/*"
        multiple
        onChange={handleFileChange}
      />
      {audioFiles.length > 0 && (
        <div>
          <h3>Selected Audio Files:</h3>
          <ul>
            {audioFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AudioFileSelector;
